module.exports = __webpack_public_path__ + "static/media/19ESCAP18.9e3dde81.jpg";